import { api } from '../lib/gapApi';

export const generateProposal = async (analysisId) => {
  const response = await api.post(`/analysis/${analysisId}/generate-proposal`);
  return response.data;
};

export const getAnalysisDocuments = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/documents`);
  return response.data;
};
